import { MakeCall } from './createMakeCall';
import { PartnerListingClick } from './types/Listing';
import { APIV2_URL } from './constants';

export interface PartnerClickData {
  identity: string;
  eventTime: string;
}

const generateListingClick = (makeCall: MakeCall) => (
  listingId: number,
  data: PartnerClickData,
) =>
  makeCall<PartnerListingClick>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/generate-click`,
    { data },
  );

export default generateListingClick;
